"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_PROFIT_EVENTS = void 0;
exports.STORE_PROFIT_EVENTS = {
    ORDER_PAID: 'ORDER_PAID',
    ORDER_REFUNDED: 'ORDER_REFUNDED',
    ORDER_CHARGEBACK: 'ORDER_CHARGEBACK',
    PAYOUT_SENT: 'PAYOUT_SENT',
    PAYOUT_REQUESTED: 'PAYOUT_REQUESTED',
    MANUAL_INCREASED: 'MANUAL_INCREASED',
    MANUAL_DECREASED: 'MANUAL_DECREASED'
};
//# sourceMappingURL=storeProfitEvents.js.map